<template>
  <div class="text-center">
    <v-snackbar
      :value="snackBarInfo.visible"
      timeout="-1"
      :color="snackBarInfo.color"
    >
      {{ snackBarInfo.title }}

      <template v-slot:action="{ attrs }">
        <v-btn small fab text v-bind="attrs" @click="closeSnackBar">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data: () => ({}),
  computed: {
    snackBarInfo() {
      return this.$store.getters['snackbar/getSnackBarState']
    }
  },
  methods: {
    closeSnackBar() {
      this.$store.commit('snackbar/UPDATE_VISIBLE', false)
    }
  }
}
</script>
